import React from 'react';
import { Link } from 'react-router-dom';

const STEPS = [
  { key: 'cart', label: 'Cart', to: '/cart' },
  { key: 'checkout', label: 'Details', to: '/checkout' },
  { key: 'pay', label: 'Payment', to: null },
];

export default function CheckoutProgress({ current = 'cart' }) {
  const idx = STEPS.findIndex((s) => s.key === current);

  return (
    <nav className="checkout-progress" aria-label="Checkout progress">
      <ol className="checkout-progress__list">
        {STEPS.map((step, i) => {
          const done = i < idx;
          const active = i === idx;
          const upcoming = i > idx;
          const content = (
            <>
              <span className="checkout-progress__dot" aria-hidden>
                {done ? '✓' : i + 1}
              </span>
              <span className="checkout-progress__label">{step.label}</span>
            </>
          );
          return (
            <li
              key={step.key}
              className={`checkout-progress__step${active ? ' checkout-progress__step--active' : ''}${
                done ? ' checkout-progress__step--done' : ''
              }${upcoming ? ' checkout-progress__step--upcoming' : ''}`}
              aria-current={active ? 'step' : undefined}
            >
              {step.to && (done || (active && step.key === 'cart')) ? (
                <Link to={step.to} className="checkout-progress__link">
                  {content}
                </Link>
              ) : (
                <span className="checkout-progress__link checkout-progress__link--static">{content}</span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
